import { LineSeriesOption } from 'echarts/charts';
import { formatTypes } from '../models';

export type LineChartProps = {
  metadata: LineMeta;
  direction?: 'horizontal' | 'vertical';
  data: {}[];
  seriesProp?: LineSeriesProp;
  className: string;
  formatter?: (value: number | string, format: formatTypes) => number | string;
};

export type LineMeta = {
  title: string;
  type: LineTypes;
  description?: string;
  isExportable: boolean;
  xAxis: string;
  legends: string[];
  yAxis: {
    [key: string]: string;
  };
  format: formatTypes;
};

export enum LineTypes {
  Default = 'Default',
  YoY = 'YoY',
}

export type LineSeriesProp = Omit<LineSeriesOption, 'type' | 'label'>;
